"use client";

import dynamic from "next/dynamic";

const ModulesOrbitalTimeline = dynamic(
  () =>
    import("./ModulesOrbitalTimeline").then((m) => m.ModulesOrbitalTimeline),
  {
    ssr: false,
    loading: () => (
      <div
        style={{
          width: 520,
          maxWidth: "100%",
          aspectRatio: "1",
          borderRadius: 24,
          background: "rgba(5,60,97,0.04)",
          border: "1.5px dashed rgba(5,60,97,0.10)",
        }}
      />
    ),
  }
);

export function ModulesOrbitalWrapper({ locale = "en" }: { locale?: string }) {
  return <ModulesOrbitalTimeline locale={locale} />;
}
